import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=4836d941"
import script from "./payRecord.vue?vue&type=script&lang=js"
export * from "./payRecord.vue?vue&type=script&lang=js"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=4836d941&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports